import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { Button, Typography, Box, Container } from '@mui/material';
import { styled } from '@mui/system';
var NotFoundContainer = styled(Box)({
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #e8f5e9, #c8e6c9)' // Gradient xanh lá
});
var NotFoundContent = styled(Box)({
    textAlign: 'center',
    background: '#ffffff',
    borderRadius: '15px',
    padding: '2.5rem',
    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
    animation: 'fadeIn 1s ease-in-out',
    '@keyframes fadeIn': {
        '0%': { opacity: 0, transform: 'translateY(-20px)' },
        '100%': { opacity: 1, transform: 'translateY(0)' }
    }
});
var NotFound = function () {
    return (_jsx(NotFoundContainer, { children: _jsx(Container, { maxWidth: 'sm', children: _jsxs(NotFoundContent, { children: [_jsx(Typography, { variant: 'h1', className: 'text-green-600', sx: {
                            fontSize: { xs: '4rem', md: '7rem' },
                            fontWeight: 'bold',
                            textShadow: '2px 2px 4px rgba(76, 175, 80, 0.3)'
                        }, children: "404" }), _jsx(Typography, { variant: 'h5', className: 'text-green-800', sx: { mt: 2, mb: 4 }, children: "Oops! Page not found." }), _jsx(Button, { component: Link, to: '/', variant: 'contained', className: 'bg-green-500 hover:bg-green-600', sx: {
                            padding: '10px 30px',
                            borderRadius: '25px',
                            textTransform: 'none',
                            fontSize: '1.125rem',
                            transition: 'all 0.3s ease'
                        }, children: "Back to home" })] }) }) }));
};
export default NotFound;
